const subcategories = [
	{
		path: '/deals/subcategories/list',
		name: 'shop-subcategories-list',
		component: () => import('@/views/shop/subcategories/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,categories',
		},
	},
]

export default subcategories
